import { Box, Button, IconButton, useTheme } from '@mui/material';
import React, { useState } from 'react';
import RenderHTML from '../../../components/preview/RenderHTML';
import PopUpTextEditor from '../../../components/popup/PopUpTextEditor';
import { useTranslation } from 'react-i18next';
import AddIcon from '@mui/icons-material/Add';
import { API_PATCH, DBRequest, useConfig } from '../../../api/api';
import ExoDialog from '../../../components/exo/ExoDialog';
import ExoExplorer from '../../../components/exo/ExoExplorer';
import MediaPreview from '../../../components/exo/explorer/MediaPreview';
import { tokens } from '../../../global/theme/tokens';
import { ProjectAddElementButton } from '../../../components/exo/project/ProjectAddElementButton';
import DeleteIcon from '@mui/icons-material/Delete';
import ExoProcessing from '../../../components/exo/ExoProcessing';

export const SalesObjectLevelFiles = ({
  files,
  levelId,
  onChange,
  addLabel,
  fileType = 'MEDIA',
  arrayKey = 'files',
  isEditMode,
}) => {
  const { t } = useTranslation();
  const config = useConfig();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const [isProcessing, setIsProcessing] = useState(false);
  const [open, setOpen] = useState(false);
  function handleChange(data) {
    setOpen(false);
    DBRequest({
      config,
      path: `sales-object-levels/${levelId}`,
      method: API_PATCH({ [arrayKey]: data }),
      onLoading: setIsProcessing,
      onResponse: onChange,
    });
  }

  function handleRemoveItem(element) {
    const newItems = files.filter((obj) => element.id !== obj.id);
    handleChange(newItems);
  }

  return (
    <>
      {files && files.length > 0 ? (
        <Box className="grid w-full grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-1">
          {files.map((img) => (
            <Box
              key={img.id}
              sx={{
                bgcolor: colors.card,
                '& .delButtonImage': {
                  transition: '0.3s ease',
                  bgcolor: colors.error + '30',
                  color: colors.error,
                  border: `1px solid ${colors.error}80`,
                  opacity: 0,
                  transform: 'translate(-5px)',
                  position: 'absolute',
                  top: '5px',
                  right: '5px',
                },
                ':hover': {
                  '& .editButton, & .delButtonImage': {
                    opacity: 1,
                    transform: 'translate(0px)',
                  },
                },
              }}
              className="rounded-md relative"
            >
              <MediaPreview
                src={img.temporaryUrl}
                mimeType={img.mimeType}
                size="100%"
              />
              {isEditMode && (
                <IconButton
                  onClick={() => handleRemoveItem(img)}
                  size="small"
                  className="delButtonImage"
                  sx={{
                    position: 'absolute',
                  }}
                >
                  <DeleteIcon sx={{ fontSize: '15px' }} />
                </IconButton>
              )}
            </Box>
          ))}
          {isEditMode && (
            <ProjectAddElementButton onClick={() => setOpen(true)} />
          )}
        </Box>
      ) : (
        <>
          {isEditMode && (
            <Button
              onClick={() => setOpen(true)}
              sx={{
                padding: '5px 10px',
                justifyContent: 'start',
                textAlign: 'left',
              }}
              variant="outlined"
              className="w-full"
            >
              <AddIcon className="mr-1" />
              {addLabel || t('Add file')}
            </Button>
          )}
        </>
      )}
      <ExoProcessing open={isProcessing} label={t('Processing')} />
      <ExoDialog open={open} onClose={() => setOpen(false)}>
        <ExoExplorer
          onSelect={handleChange}
          multiSelect
          preSelected={files}
          maxItems={20}
          maxSizeKB={9999}
          mediaType={fileType}
        />
      </ExoDialog>
    </>
  );
};
